import {Injectable} from '@angular/core';
import * as APIM from '@common/utils/dist/models/api-messages.js';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {NEVER, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {WSMessageReceiverService} from '@services/ws-message-receiver.service';

@Injectable()
export class ScormMessageProcessor implements WebsocketMessageProcessor {
  constructor(private wsMessageReceiverService: WSMessageReceiverService) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (msg.int === APIM.EventIntent.ScormUploaded) {
      return this.wsMessageReceiverService
        .receive<APIM.NotifyRequest>(msg)
        .pipe(
          map((eventData) => {
            params.wsAPI.result(msg, eventData);
          }),
        );
    }
    return NEVER;
  }
}
